"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = __importDefault(require("../styles/theme"));
const StyledLink = styled_components_1.default.a `
  color: ${(props) => props.theme.colors.textLink};
  text-decoration: ${(props) => (props.underline ? 'underline' : 'none')};

  &:hover {
    text-decoration: underline;
  }
  &:focus-visible {
    outline: ${theme_1.default.outline};
    outline-offset: 5px;
  }
`;
const Link = (_a) => {
    var { underline = true, newTab = false } = _a, props = __rest(_a, ["underline", "newTab"]);
    return (react_1.default.createElement(StyledLink, Object.assign({ underline: underline, target: newTab ? '_blank' : undefined, rel: newTab ? 'noreferrer noopener' : undefined }, props)));
};
exports.Link = Link;
exports.default = exports.Link;
